/*
Copyright 2022 DigitalOcean

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

export default {
    title: 'Bandwidth Calculator',
    description: 'A tool to help calculate and explain bandwidth allowances for Droplets on DigitalOcean.',
    forMoreInfo: 'For more info, see our',
    docs: 'bandwidth billing docs',
    droplets: 'Droplets',
    selectToStart: 'Select a Droplet below to get started estimating the bandwidth allowance on your account!',
    addADroplet: 'Add a Droplet',
    oss: 'This tool is {link|open-source on GitHub|https://github.com/do-community/bandwidth-tool} under the {link|Apache-2.0|https://github.com/do-community/bandwidth-tool/blob/master/LICENSE} license! We welcome feedback and contributions.',
};
